<div class="lm-page">

  <!-- HEADER -->
  <div class="lm-page-header">
    <button class="lm-back-btn" (click)="navigateBack()" [title]="'leave_management.create_leave.title.back' | transloco">
      <mat-icon>{{ 'leave_management.create_leave.arrow_back' | transloco }}</mat-icon>
    </button>
    <span class="lm-page-title">{{ editingId ? 'Edit Leave' : 'Create New Leave' }}</span>
  </div>

  <lm-loading-overlay [show]="isLoadingForm" message="Loading..."></lm-loading-overlay>
  <lm-loading-overlay [show]="isSaving" message="Saving..."></lm-loading-overlay>

  <!-- CARD -->
  <div class="lm-card cl-card">
    <form [formGroup]="form" (ngSubmit)="onCreate()">

      <!-- Section: Basic Info -->
      <div class="cl-section">
        <div class="cl-top-row">
          <div class="cl-top-type">
            <label class="lm-field-label">Leave Type Name <span class="lm-req">*</span></label>
            <mat-form-field appearance="outline" class="lm-full-width"
              [class.cl-field-invalid]="form.get('leaveType')?.invalid && form.get('leaveType')?.touched">
              <input matInput formControlName="leaveType" [placeholder]="'leave_management.create_leave.placeholder.e_g_sick_leave' | transloco" [matAutocomplete]="auto" />
              <mat-icon matSuffix class="cl-dropdown-arrow">{{ 'leave_management.create_leave.arrow_drop_down' | transloco }}</mat-icon>
              <mat-autocomplete #auto="matAutocomplete">
                @for (type of  ((filteredLeaveTypes | async)) | ersSortBy; track type) {
                <mat-option [value]="type">
                  {{ type }}
                </mat-option>
                }
                @if (!(filteredLeaveTypes | async) || (filteredLeaveTypes | async)?.length === 0) {
                <mat-option disabled>
                  {{ 'leave_management.create_leave.no_matching_leave_types' | transloco }}
                </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
            @if (form.get('leaveType')?.invalid && form.get('leaveType')?.touched) {
            <div class="cl-field-error">
              {{ 'leave_management.create_leave.leave_type_name_is_required' | transloco }}
            </div>
            }
          </div>
          <div class="cl-top-active">
            <span class="lm-field-label">{{ 'leave_management.create_leave.active' | transloco }}</span>
            <mat-slide-toggle formControlName="isActive" color="primary"></mat-slide-toggle>
            <div class="cl-field-error" style="visibility: hidden;">-</div>
          </div>
          <div class="cl-top-period">
            <label class="lm-field-label">{{ 'leave_management.create_leave.leave_period_start' | transloco }}</label>
            <mat-form-field appearance="outline" class="lm-full-width">
              <input matInput [matDatepicker]="periodPicker" formControlName="leavePeriodStart" readonly
                placeholder="DD-MM-YYYY" />
              <mat-datepicker-toggle matSuffix [for]="periodPicker"></mat-datepicker-toggle>
              <mat-datepicker #periodPicker></mat-datepicker>
            </mat-form-field>
            <div class="cl-field-error" style="visibility: hidden;">-</div>
          </div>
        </div>
        <div class="cl-checkbox-row">
          <mat-checkbox formControlName="requiresSupervisorApproval" color="primary">
            {{ 'leave_management.create_leave.requires_supervisor_approval' | transloco }}
          </mat-checkbox>
        </div>
      </div>

      <!-- Section: Gift Of Time -->
      @if (canViewGiftOfTime) {
      <div class="cl-section">
        <div class="cl-gift-card">
          <div class="cl-gift-header">
            <div class="cl-gift-header-left">
              <span class="cl-gift-icon"><svg width="50" height="50" viewBox="0 0 95 95" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <g filter="url(#filter0_d_481_8627)">
                    <rect x="12.5" y="10.5" width="70" height="70" rx="35" fill="white" shape-rendering="crispEdges" />
                    <path
                      d="M32.5039 43H62.5039V59.25C62.5039 60.9076 61.8454 62.4973 60.6733 63.6694C59.5012 64.8415 57.9115 65.5 56.2539 65.5H38.7539C37.0963 65.5 35.5066 64.8415 34.3345 63.6694C33.1624 62.4973 32.5039 60.9076 32.5039 59.25V43Z"
                      fill="url(#paint0_linear_481_8627)" />
                    <path
                      d="M62.5 35.5H32.5C31.1193 35.5 30 36.6193 30 38V43C30 44.3807 31.1193 45.5 32.5 45.5H62.5C63.8807 45.5 65 44.3807 65 43V38C65 36.6193 63.8807 35.5 62.5 35.5Z"
                      fill="url(#paint1_radial_481_8627)" />
                    <path d="M45.625 65.5V45.5H49.375V65.5H45.625Z" fill="black" />
                    <path d="M45.625 65.5V45.5H49.375V65.5H45.625Z" fill="url(#paint2_linear_481_8627)" />
                    <path d="M49.375 34.875V45.5H45.625V34.875H49.375Z" fill="black" />
                    <path d="M49.375 34.875V45.5H45.625V34.875H49.375Z" fill="url(#paint3_linear_481_8627)" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M47.5032 27.0328L47.6432 26.8878C48.4444 26.0871 49.4311 25.4967 50.5154 25.1692C51.5998 24.8417 52.7483 24.7871 53.8588 25.0105C54.9693 25.2338 56.0074 25.7281 56.8808 26.4493C57.7543 27.1706 58.4359 28.0965 58.8653 29.1447C59.2946 30.193 59.4583 31.331 59.3418 32.4578C59.2252 33.5845 58.8321 34.665 58.1974 35.6031C57.5626 36.5413 56.7058 37.3081 55.7033 37.8354C54.7007 38.3626 53.5834 38.634 52.4507 38.6253C51.4266 38.6209 50.4024 38.6201 49.3782 38.6228V38.6303L47.5032 38.6253L45.6282 38.6303V38.6228H42.5557C41.4142 38.6321 40.2883 38.3569 39.2797 37.8222C38.2711 37.2875 37.4115 36.51 36.7786 35.56C36.1456 34.61 35.7592 33.5173 35.6542 32.3806C35.5491 31.2438 35.7288 30.0988 36.177 29.0489C36.6252 27.999 37.3278 27.0772 38.2213 26.3667C39.1149 25.6563 40.1713 25.1795 41.2952 24.9794C42.4191 24.7794 43.5751 24.8623 44.6589 25.2208C45.7428 25.5793 46.7203 26.202 47.5032 27.0328ZM54.7132 29.5403C54.2762 29.1032 53.7193 28.8054 53.113 28.6848C52.5068 28.5642 51.8784 28.6261 51.3073 28.8626C50.7362 29.0992 50.2481 29.4998 49.9047 30.0139C49.5613 30.5279 49.3781 31.1322 49.3782 31.7503V34.8728H49.5082C50.5857 34.8703 51.8357 34.8703 52.4782 34.8753C53.0985 34.8804 53.7063 34.7008 54.2241 34.3593C54.742 34.0179 55.1465 33.53 55.3862 32.9579C55.6259 32.3858 55.6899 31.7553 55.57 31.1467C55.4502 30.538 55.1519 29.9789 54.7132 29.5403ZM45.6282 31.7503C45.6282 31.1312 45.4443 30.526 45.0998 30.0116C44.7553 29.4972 44.2657 29.0967 43.6933 28.8609C43.1208 28.6251 42.4912 28.5647 41.8843 28.6873C41.2775 28.8099 40.7207 29.1101 40.2847 29.5496C39.8486 29.9891 39.553 30.5483 39.4353 31.1561C39.3175 31.764 39.383 32.3931 39.6233 32.9636C39.8637 33.5342 40.2681 34.0205 40.7853 34.3609C41.3025 34.7012 41.9091 34.8803 42.5282 34.8753C43.1707 34.8703 44.4207 34.8703 45.4982 34.8703H45.6282V31.7503Z"
                      fill="url(#paint4_linear_481_8627)" />
                  </g>
                  <defs>
                    <filter id="filter0_d_481_8627" x="0" y="0" width="95" height="95" filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB">
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha" />
                      <feOffset dy="2" />
                      <feGaussianBlur stdDeviation="6.25" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_481_8627" />
                      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_481_8627" result="shape" />
                    </filter>
                    <linearGradient id="paint0_linear_481_8627" x1="45.5889" y1="74.3425" x2="45.5889" y2="34.2375"
                      gradientUnits="userSpaceOnUse">
                      <stop stop-color="#BB45EA" />
                      <stop offset="0.348" stop-color="#8B57ED" />
                      <stop offset="1" stop-color="#5B2AB5" />
                    </linearGradient>
                    <radialGradient id="paint1_radial_481_8627" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(47.5 31.75) scale(45.078 15.625)">
                      <stop offset="0.196" stop-color="#5B2AB5" />
                      <stop offset="0.763" stop-color="#8B57ED" />
                      <stop offset="1" stop-color="#BB45EA" />
                    </radialGradient>
                    <linearGradient id="paint2_linear_481_8627" x1="45.625" y1="34.25" x2="45.625" y2="62.0225"
                      gradientUnits="userSpaceOnUse">
                      <stop stop-color="#FB5937" />
                      <stop offset="1" stop-color="#FFCD0F" />
                    </linearGradient>
                    <linearGradient id="paint3_linear_481_8627" x1="45.625" y1="-10.66" x2="45.625" y2="63.715"
                      gradientUnits="userSpaceOnUse">
                      <stop stop-color="#FB5937" />
                      <stop offset="1" stop-color="#FFCD0F" />
                    </linearGradient>
                    <linearGradient id="paint4_linear_481_8627" x1="54.1007" y1="38.6278" x2="46.9882" y2="10.3528"
                      gradientUnits="userSpaceOnUse">
                      <stop stop-color="#FF6F47" />
                      <stop offset="1" stop-color="#FFCD0F" />
                    </linearGradient>
                  </defs>
                </svg>
              </span>
              <div class="cl-gift-info">
                <span class="cl-gift-title">{{ 'leave_management.create_leave.gift_of_time' | transloco }}</span>
                <span class="cl-gift-sub">{{ 'leave_management.create_leave.only_unused_approved_leave_types_can_be_gifted' | transloco }}</span>
              </div>
            </div>
            <mat-slide-toggle formControlName="giftOfTime" color="primary"></mat-slide-toggle>
          </div>
        </div>

        @if (form.get('giftOfTime')?.value) {
        <div class="cl-gift-fields-panel">
          <div class="cl-two-col">
            <div class="cl-field-group">
              <label class="lm-field-label">
                Maximum days allowed to gift <span class="lm-req">*</span>
                <mat-icon class="lm-info-icon"
                  [matTooltip]="'leave_management.create_leave.matTooltip.max_consecutive_days_an_employee_can_gift' | transloco">{{ 'leave_management.create_leave.info_outline' | transloco }}</mat-icon>
              </label>
              <mat-form-field appearance="outline" class="lm-full-width"
                [class.cl-field-invalid]="form.get('maxGiftDays')?.invalid && form.get('maxGiftDays')?.touched">
                <input matInput type="number" min="1" formControlName="maxGiftDays" />
              </mat-form-field>
            @if (form.get('maxGiftDays')?.invalid && form.get('maxGiftDays')?.touched) {
            <div class="cl-field-error">
                @if (form.get('maxGiftDays')?.errors?.['required']) { <span>{{ 'leave_management.create_leave.this_field_is_required' | transloco }}</span> }
                @if (form.get('maxGiftDays')?.errors?.['min']) { <span>{{ 'leave_management.create_leave.must_be_at_least_1' | transloco }}</span> }
            </div>
            }
            </div>
            <div class="cl-field-group">
              <label class="lm-field-label">{{ 'leave_management.create_leave.gift_expiry_date' | transloco }}</label>
              <mat-form-field appearance="outline" class="lm-full-width">
                <input matInput [matDatepicker]="giftExpiryPicker" formControlName="giftExpiryDate" readonly
                  placeholder="DD-MM-YYYY" />
                <mat-datepicker-toggle matSuffix [for]="giftExpiryPicker"></mat-datepicker-toggle>
                <mat-datepicker #giftExpiryPicker></mat-datepicker>
              </mat-form-field>
              <div class="cl-field-error" style="visibility: hidden;">-</div>
            </div>
          </div>
          <div class="cl-two-col">
            <div class="cl-field-group">
              <label class="lm-field-label">Transfer Limit (Per Individual)</label>
              <mat-form-field appearance="outline" class="lm-full-width">
                <input matInput type="number" min="1" formControlName="transferLimit" />
              </mat-form-field>
              <div class="cl-field-error" style="visibility: hidden;">-</div>
            </div>
            <div class="cl-field-group cl-align-center">
              <mat-checkbox formControlName="giftReasonRequired" color="primary">
                {{ 'leave_management.create_leave.gift_reason_required' | transloco }}
              </mat-checkbox>
              <div class="cl-field-error" style="visibility: hidden;">-</div>
            </div>
          </div>
        </div>
        }
      </div>
      }

      <!-- Section: Allocation -->
      <div class="cl-section">
        <p class="cl-section-label">{{ 'leave_management.create_leave.allocation' | transloco }}</p>
        <div class="cl-two-col">
          <div class="cl-field-group">
            <label class="lm-field-label">Frequency of Allocation <span class="lm-req">*</span></label>
            <mat-form-field appearance="outline" class="lm-full-width"
              [class.cl-field-invalid]="form.get('frequencyOfAllocation')?.invalid && form.get('frequencyOfAllocation')?.touched">
              <mat-select formControlName="frequencyOfAllocation">
                @for (freq of allocationFrequencies; track freq.id) {
                <mat-option [value]="freq.id.toLowerCase()">{{ freq.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if (form.get('frequencyOfAllocation')?.invalid && form.get('frequencyOfAllocation')?.touched) {
            <div class="cl-field-error">
              {{ 'leave_management.create_leave.allocation_frequency_is_required' | transloco }}
            </div>
            }
          </div>
          <div class="cl-field-group">
            <label class="lm-field-label">No. of leaves <span class="lm-muted-text">/ year</span> <span
                class="lm-req">*</span></label>
            <div class="cl-leaves-row">
              <mat-form-field appearance="outline" class="lm-full-width"
                [class.cl-field-invalid]="form.get('leavesPerYear')?.invalid && form.get('leavesPerYear')?.touched">
                <input matInput type="number" min="1" formControlName="leavesPerYear" />
              </mat-form-field>
              @if (frequencyBadge) { <span class="cl-freq-badge">{{ frequencyBadge }}</span> }
            </div>
            @if (form.get('leavesPerYear')?.invalid && form.get('leavesPerYear')?.touched) {
            <div class="cl-field-error">
              @if (form.get('leavesPerYear')?.errors?.['required']) { <span>{{ 'leave_management.create_leave.number_of_leaves_is_required' | transloco }}</span> }
              @if (form.get('leavesPerYear')?.errors?.['min']) { <span>{{ 'leave_management.create_leave.must_be_at_least_1' | transloco }}</span> }
            </div>
            }
          </div>
        </div>
      </div>

      <!-- Section: Valid Till -->
      <div class="cl-section">
        <p class="cl-section-label">{{ 'leave_management.create_leave.valid_till' | transloco }}</p>
        <div class="cl-three-col">
          <div class="cl-field-group">
            <label class="lm-field-label">{{ 'leave_management.create_leave.start_date' | transloco }}</label>
            <mat-form-field appearance="outline" class="lm-full-width">
              <input matInput [matDatepicker]="validStartPicker" formControlName="validStart" readonly
                placeholder="DD-MM-YYYY" />
              <mat-datepicker-toggle matSuffix [for]="validStartPicker"></mat-datepicker-toggle>
              <mat-datepicker #validStartPicker></mat-datepicker>
            </mat-form-field>
            <div class="cl-field-error" style="visibility: hidden;">-</div>
          </div>
          <div class="cl-field-group">
            <label class="lm-field-label">Duration (months)</label>
            <mat-form-field appearance="outline" class="lm-full-width">
              <input matInput type="number" min="1" formControlName="duration" [placeholder]="'leave_management.create_leave.placeholder.e_g_12' | transloco" />
            </mat-form-field>
            <div class="cl-field-error" style="visibility: hidden;">-</div>
          </div>
          <div class="cl-field-group">
            <label class="lm-field-label">{{ 'leave_management.create_leave.end_date' | transloco }}</label>
            <mat-form-field appearance="outline" class="lm-full-width">
              <input matInput [matDatepicker]="validEndPicker" formControlName="validEnd" readonly
                placeholder="DD-MM-YYYY" />
              <mat-datepicker #validEndPicker disabled="true"></mat-datepicker>
            </mat-form-field>
            <div class="cl-field-error" style="visibility: hidden;">-</div>
          </div>
        </div>
      </div>

      <!-- Section: Carry Forward -->
      <div class="cl-section">
        <div class="cl-toggle-row">
          <span class="lm-field-label cl-toggle-label">{{ 'leave_management.create_leave.carry_forward' | transloco }}</span>
          <mat-slide-toggle formControlName="carryForward" color="primary"></mat-slide-toggle>
        </div>
        @if (form.get('carryForward')?.value) {
        <div class="cl-two-col cl-mt-sm"
          [style.grid-template-columns]="form.get('carryForwardCount')?.value === 'custom' ? '1fr 1fr 1fr' : '1fr 1fr'">
          <div class="cl-field-group">
            <label class="lm-field-label">No. of carry forwards <span class="lm-req">*</span></label>
            <mat-form-field appearance="outline" class="lm-full-width"
              [class.cl-field-invalid]="form.get('carryForwardCount')?.invalid && form.get('carryForwardCount')?.touched">
              <mat-select formControlName="carryForwardCount">
                <mat-option value="half">{{ 'leave_management.create_leave.half' | transloco }}</mat-option>
                <mat-option value="full">{{ 'leave_management.create_leave.full' | transloco }}</mat-option>
                <mat-option value="custom">{{ 'leave_management.create_leave.custom' | transloco }}</mat-option>
              </mat-select>
            </mat-form-field>
            @if (form.get('carryForwardCount')?.invalid && form.get('carryForwardCount')?.touched) {
            <div class="cl-field-error">
              {{ 'leave_management.create_leave.please_select_a_carry_forward_option' | transloco }}
            </div>
            }
            @if (carryForwardBadge) { <span class="cl-carry-badge">{{ carryForwardBadge }}</span> }
          </div>
          @if (form.get('carryForwardCount')?.value === 'custom') {
          <div class="cl-field-group">
            <label class="lm-field-label">Carry forward % <span class="lm-req">*</span></label>
            <mat-form-field appearance="outline" class="lm-full-width"
              [class.cl-field-invalid]="form.get('customCarryPct')?.invalid && form.get('customCarryPct')?.touched">
              <input matInput type="number" formControlName="customCarryPct"
                [placeholder]="'leave_management.create_leave.placeholder.e_g_75' | transloco" min="1" max="100" />
              <span matSuffix>%</span>
            </mat-form-field>
            @if (form.get('customCarryPct')?.invalid && form.get('customCarryPct')?.touched) {
            <div class="cl-field-error">
              {{ 'leave_management.create_leave.enter_a_value_between_1_and_100' | transloco }}
            </div>
            }
          </div>
          }
          <div class="cl-field-group">
            <label class="lm-field-label">{{ 'leave_management.create_leave.expiry_date_of_carried_leave' | transloco }}</label>
            <mat-form-field appearance="outline" class="lm-full-width">
              <input matInput [matDatepicker]="carryExpiryPicker" formControlName="carryExpiryDate" readonly
                placeholder="DD-MM-YYYY" />
              <mat-datepicker-toggle matSuffix [for]="carryExpiryPicker"></mat-datepicker-toggle>
              <mat-datepicker #carryExpiryPicker></mat-datepicker>
            </mat-form-field>
            <div class="cl-field-error" style="visibility: hidden;">-</div>
          </div>
        </div>
        }
      </div>

      <!-- Section: Accrual Policy (PBI 34800) -->
      <div class="cl-section">
        <p class="cl-section-label">Accrual Policy</p>
        <div class="cl-two-col">
          <div class="cl-field-group">
            <label class="lm-field-label">Accrual method</label>
            <mat-form-field appearance="outline" class="lm-full-width">
              <mat-select formControlName="accrualMethod">
                <mat-option value="PER_PERIOD">Fixed per period</mat-option>
                <mat-option value="PER_HOURS_WORKED">By hours worked</mat-option>
              </mat-select>
            </mat-form-field>
            <div class="cl-field-error" style="visibility: hidden;">-</div>
          </div>
          @if (form.get('accrualMethod')?.value === 'PER_HOURS_WORKED') {
          <div class="cl-field-group">
            <label class="lm-field-label">Days accrued per hour worked</label>
            <mat-form-field appearance="outline" class="lm-full-width">
              <input matInput type="number" min="0" step="0.001" formControlName="accrualRatePerHour"
                placeholder="e.g. 0.05" />
            </mat-form-field>
            <div class="cl-field-error" style="visibility: hidden;">-</div>
          </div>
          }
        </div>

        <div class="cl-two-col">
          <div class="cl-field-group cl-align-center">
            <mat-checkbox formControlName="prorateFirstPeriod" color="primary">
              Prorate the first period for mid-period joiners
            </mat-checkbox>
            <div class="cl-field-error" style="visibility: hidden;">-</div>
          </div>
          @if (form.get('prorateFirstPeriod')?.value) {
          <div class="cl-field-group">
            <label class="lm-field-label">Proration basis</label>
            <mat-form-field appearance="outline" class="lm-full-width">
              <mat-select formControlName="prorationBasis">
                <mat-option value="PERIOD_START">Policy start date</mat-option>
                <mat-option value="HIRE_DATE">Employee hire date</mat-option>
              </mat-select>
            </mat-form-field>
            <div class="cl-field-error" style="visibility: hidden;">-</div>
          </div>
          }
        </div>

        <div class="cl-two-col">
          <div class="cl-field-group">
            <label class="lm-field-label">Rounding</label>
            <mat-form-field appearance="outline" class="lm-full-width">
              <mat-select formControlName="roundingMode">
                <mat-option value="NONE">No rounding</mat-option>
                <mat-option value="UP">Round up</mat-option>
                <mat-option value="DOWN">Round down</mat-option>
                <mat-option value="NEAREST">Round to nearest</mat-option>
              </mat-select>
            </mat-form-field>
            <div class="cl-field-error" style="visibility: hidden;">-</div>
          </div>
          @if (form.get('roundingMode')?.value !== 'NONE') {
          <div class="cl-field-group">
            <label class="lm-field-label">Round to the nearest</label>
            <mat-form-field appearance="outline" class="lm-full-width">
              <input matInput type="number" min="0" step="0.25" formControlName="roundingIncrement"
                placeholder="e.g. 0.5" />
              <span matSuffix>days</span>
            </mat-form-field>
            <div class="cl-field-error" style="visibility: hidden;">-</div>
          </div>
          }
        </div>

        <!-- Tenure tiers -->
        <div class="cl-tenure-tiers" formArrayName="tenureTiers">
          <div class="cl-tenure-header">
            <span class="lm-field-label cl-toggle-label">Tenure tiers</span>
            <span class="lm-muted-text">Raise the per-period amount at service milestones — the highest matching tier
              wins.</span>
          </div>
          @for (tier of tenureTiers.controls; track tier; let i = $index) {
          <div class="cl-two-col cl-tenure-row" [formGroupName]="i">
            <div class="cl-field-group">
              <label class="lm-field-label">After (months of service)</label>
              <mat-form-field appearance="outline" class="lm-full-width">
                <input matInput type="number" min="0" formControlName="minMonthsOfService" placeholder="e.g. 24" />
              </mat-form-field>
            </div>
            <div class="cl-field-group cl-tenure-qty">
              <label class="lm-field-label">Days per period</label>
              <div class="cl-leaves-row">
                <mat-form-field appearance="outline" class="lm-full-width">
                  <input matInput type="number" min="0" step="0.01" formControlName="quantityPerPeriod"
                    placeholder="e.g. 1.5" />
                </mat-form-field>
                <button type="button" class="cl-file-chip-remove" (click)="removeTier(i)" title="Remove tier">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </div>
          </div>
          }
          <button type="button" class="cl-attach-btn" (click)="addTier()">
            <mat-icon>add</mat-icon>
            Add tenure tier
          </button>
        </div>
      </div>

      <!-- Section: Notes and Attachment -->
      <div class="cl-section">
        <div class="cl-notes-header">
          <span class="lm-field-label cl-toggle-label">Notes <span class="lm-muted-text">(Optional)</span></span>
          <span class="cl-char-count">{{ noteCharCount }}/100</span>
        </div>
        <mat-form-field appearance="outline" class="lm-full-width">
          <textarea matInput formControlName="notes" rows="3" maxlength="100" (input)="onNotesInput()"></textarea>
        </mat-form-field>
        <div class="cl-attachment-row">
          <button type="button" class="cl-attach-btn" (click)="fileInput.click()">
            <mat-icon>{{ 'leave_management.create_leave.attach_file' | transloco }}</mat-icon>
            {{ 'leave_management.create_leave.add_attachment' | transloco }}
          </button>
          <input #fileInput type="file" hidden multiple (change)="onFileSelected($event)"
            accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg" />
        </div>
        @if (attachments.length > 0) {
        <div class="cl-attachments-list">
          @for (att of attachments; track att.name; let i = $index) {
            <!-- Pending (new file, not yet uploaded) -->
            @if (att.file) {
            <div class="cl-file-chip">
              <mat-icon style="font-size:14px;width:14px;height:14px">{{ 'leave_management.create_leave.description' | transloco }}</mat-icon>
              <span class="cl-file-chip-name">{{ att.name }}</span>
              <button type="button" class="cl-file-chip-remove" (click)="removeAttachment(i)" [title]="'leave_management.create_leave.title.remove' | transloco">
                <mat-icon>{{ 'leave_management.create_leave.close' | transloco }}</mat-icon>
              </button>
            </div>
            }
            <!-- Saved (has url) -->
            @if (!att.file && att.url) {
            <div class="cl-file-chip cl-file-chip--saved">
              <mat-icon style="font-size:14px;width:14px;height:14px">{{ 'leave_management.create_leave.description' | transloco }}</mat-icon>
              <button type="button" class="cl-file-download-inline" (click)="previewAttachment(i)" [title]="'leave_management.create_leave.title.preview' | transloco">
                {{ att.name }}
              </button>
              <button type="button" class="cl-file-chip-icon" (click)="downloadAttachment(i)" [title]="'leave_management.create_leave.title.download' | transloco">
                <mat-icon style="font-size:14px;width:14px;height:14px">{{ 'leave_management.create_leave.download' | transloco }}</mat-icon>
              </button>
              <button type="button" class="cl-file-chip-remove" (click)="removeAttachment(i)" [title]="'leave_management.create_leave.title.remove' | transloco">
                <mat-icon>{{ 'leave_management.create_leave.close' | transloco }}</mat-icon>
              </button>
            </div>
            }
          }
        </div>
        }
      </div>

      <!-- Footer Buttons -->
      <div class="lm-footer">
        <button type="button" class="lm-btn lm-btn--danger-outline" (click)="onDelete()">{{ 'leave_management.create_leave.delete' | transloco }}</button>
        <div class="lm-footer-right">
          <button type="button" class="lm-btn lm-btn--reset" (click)="onReset()">{{ 'leave_management.create_leave.reset' | transloco }}</button>
          <button type="submit" class="lm-btn lm-btn--primary" [disabled]="isUploading || isSaving">
            @if (isSaving || isUploading) { <span class="lm-btn-spinner"></span> }
            {{ isUploading ? 'Uploading...' : isSaving ? 'Saving...' : (editingId ? 'Update' : 'Create') }}
          </button>
        </div>
      </div>

    </form>
  </div>

  <!-- Accrual Simulation (PBI 34800) — edit mode only; previews the SAVED policy -->
  @if (editingId) {
  <div class="lm-card cl-card cl-sim-card">
    <div class="cl-sim-header">
      <p class="cl-section-label">Accrual Simulation</p>
      <span class="lm-muted-text">Preview what this policy accrues for a sample employee. Reflects the last saved
        configuration — save first to preview new changes. Nothing is written to balances.</span>
    </div>
    <div class="cl-two-col cl-sim-controls">
      <div class="cl-field-group">
        <label class="lm-field-label">As of date</label>
        <mat-form-field appearance="outline" class="lm-full-width">
          <input matInput [matDatepicker]="simPicker" [(ngModel)]="simAsOfDate" [ngModelOptions]="{ standalone: true }"
            readonly placeholder="Today" />
          <mat-datepicker-toggle matSuffix [for]="simPicker"></mat-datepicker-toggle>
          <mat-datepicker #simPicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="cl-field-group cl-align-center">
        <button type="button" class="lm-btn lm-btn--primary" (click)="runSimulation()" [disabled]="isSimulating">
          @if (isSimulating) { <span class="lm-btn-spinner"></span> }
          {{ isSimulating ? 'Simulating...' : 'Preview accrual' }}
        </button>
      </div>
    </div>
    @if (hasSimulated) {
      @if (simulationRows.length > 0) {
      <div class="cl-sim-grid">
        <ers-grid [rowData]="simulationRows" [columnDefs]="simColumnDefs" [gridOptions]="simGridOptions"></ers-grid>
      </div>
      } @else {
      <div class="cl-sim-empty lm-muted-text">No accrual periods projected for this policy up to the selected date.</div>
      }
    }
  </div>
  }
</div>